// extracted by mini-css-extract-plugin
export default {"content":"Layout_content__PWopC","iframe":"Layout_iframe__gKCHE"};